// extracted by mini-css-extract-plugin
module.exports =  {"member-since":"lKv4QPx","memberSince":"lKv4QPx"};